import React, { useEffect, useState } from 'react';
import { ExternalLink, Mail, MessageCircle, X } from 'lucide-react';
import { SALE_TICKER_CONFIG } from '../config/siteContact';

export const SALE_TICKER_STORAGE_KEY = 'valorex_sale_ticker_hidden';

export const shouldShowSaleTickerInitially = () => {
  if (!SALE_TICKER_CONFIG.enabled) return false;
  try {
    return window.sessionStorage.getItem(SALE_TICKER_STORAGE_KEY) !== '1';
  } catch {
    return true;
  }
};

const TickerContent = ({ duplicate = false }) => {
  const tabIndex = duplicate ? -1 : undefined;
  const emailHref = `mailto:${SALE_TICKER_CONFIG.email}`;

  return (
    <span className="sale-ticker__group" aria-hidden={duplicate ? 'true' : undefined}>
      <span className="sale-ticker__badge">{SALE_TICKER_CONFIG.badge}</span>
      <span>{SALE_TICKER_CONFIG.message}</span>
      <span className="sale-ticker__dot">•</span>
      <span>{SALE_TICKER_CONFIG.detail}</span>
      <span className="sale-ticker__dot">•</span>
      <a
        href={emailHref}
        tabIndex={tabIndex}
        className="sale-ticker__link"
        aria-label="Email ValoRex acquisition inquiries"
      >
        <Mail className="w-3.5 h-3.5" />
        {SALE_TICKER_CONFIG.email}
      </a>
      {SALE_TICKER_CONFIG.discordUrl && (
        <>
          <span className="sale-ticker__dot">•</span>
          <a
            href={SALE_TICKER_CONFIG.discordUrl}
            tabIndex={tabIndex}
            target="_blank"
            rel="noopener noreferrer"
            className="sale-ticker__link"
            aria-label="Open ValoRex Discord for acquisition inquiries"
          >
            <MessageCircle className="w-3.5 h-3.5" />
            Discord
            <ExternalLink className="w-3 h-3" />
          </a>
        </>
      )}
    </span>
  );
};

export default function SaleTicker({ onVisibilityChange }) {
  const [hidden, setHidden] = useState(() => !shouldShowSaleTickerInitially());

  useEffect(() => {
    onVisibilityChange?.(SALE_TICKER_CONFIG.enabled && !hidden);
  }, [hidden, onVisibilityChange]);

  if (!SALE_TICKER_CONFIG.enabled || hidden) return null;

  const closeTicker = () => {
    try {
      window.sessionStorage.setItem(SALE_TICKER_STORAGE_KEY, '1');
    } catch {
      // Session storage can be unavailable in hardened browser modes.
    }
    setHidden(true);
  };

  return (
    <div className="sale-ticker" role="region" aria-label="ValoRex sale announcement">
      <div className="sale-ticker__viewport">
        <div className="sale-ticker__track">
          <TickerContent />
          <TickerContent duplicate />
        </div>
      </div>
      <button type="button" onClick={closeTicker} className="sale-ticker__close" aria-label="Hide sale announcement">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}

